"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeFreshdeskWidget = void 0;
const FRESHDESK_SCRIPT_ID = 'Freshdesk-js-sdk';
const FRESHDESK_SCRIPT_SRC = 'https://pleohelp.freshdesk.com/webchat/js/widget.js';
const FRESHDESK_CONFIG = {
    token: '01K9S5SPZTFX5CAX9CCT0DTHE4',
    host: 'https://pleohelp.freshdesk.com',
    widgetId: '01KXZP9JACHP02B9R463NYQGKG',
};
const initFreshdesk = () => {
    window.fdWidget.init(FRESHDESK_CONFIG);
};
const injectFreshdeskScript = () => {
    if (document.getElementById(FRESHDESK_SCRIPT_ID)) {
        if (window.fdWidget) {
            initFreshdesk();
        }
        return;
    }
    const script = document.createElement('script');
    script.id = FRESHDESK_SCRIPT_ID;
    script.async = true;
    script.src = FRESHDESK_SCRIPT_SRC;
    script.onload = initFreshdesk;
    document.head.appendChild(script);
};
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
const IDLE_TIMEOUT_MS = 5000;
const FALLBACK_DELAY_MS = 3000;
/**
 * Loads the Freshdesk chatbot widget lazily — on the visitor's first interaction or once the
 * browser goes idle, whichever comes first (and only once). Deferring keeps the widget's
 * layout-shifting, bfcache-blocking third-party iframe out of the initial load/LCP/CLS window.
 */
const initializeFreshdeskWidget = () => {
    let triggered = false;
    const load = () => {
        if (triggered)
            return;
        triggered = true;
        for (const event of INTERACTION_EVENTS) {
            window.removeEventListener(event, load);
        }
        injectFreshdeskScript();
    };
    for (const event of INTERACTION_EVENTS) {
        window.addEventListener(event, load, { once: true, passive: true });
    }
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(load, { timeout: IDLE_TIMEOUT_MS });
    }
    else {
        window.setTimeout(load, FALLBACK_DELAY_MS);
    }
};
exports.initializeFreshdeskWidget = initializeFreshdeskWidget;
